import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { DialogService } from '../../../../shared/services/dialog.service';
import { ICrossFieldRule, IValidatorRule } from '../../models/validation-rule';

export type RuleToDeletePayload =
  | { kind: 'field'; rule: IValidatorRule }
  | { kind: 'cross'; rule: ICrossFieldRule }
  | null;

/**
 * Confirm-delete dialog reused for both field and cross-field rule deletes.
 * Inputs carry the pending rule, outputs surface confirm/cancel; persistence
 * stays in the parent component so this stays stateless.
 */
@Component({
  selector: 'app-delete-rule-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './delete-rule-modal.component.html',
})
export class DeleteRuleModalComponent implements AfterViewInit, OnDestroy {
  @Input() modalId!: string;
  @Input() pending: RuleToDeletePayload = null;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  @ViewChild('dialog') dialogEl!: ElementRef<HTMLDialogElement>;
  private dialog = inject(DialogService);

  ngAfterViewInit(): void {
    if (this.modalId && this.dialogEl?.nativeElement) {
      this.dialog.register(this.modalId, this.dialogEl.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.modalId) this.dialog.unregister(this.modalId);
  }

  onConfirm(): void {
    this.confirm.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
